import { Controller } from '@stimulus/core';

export default class OneDayOfferConsoleController extends Controller  {

    public closeOffer() {
        this.data.set('open', "false")
    }
}